module.exports = __webpack_public_path__ + "img/Mstorybg7.946d8fd4.jpg";